import React from 'react';
const bonuses = [{
  title: 'Límites Emocionales',
  subtitle: 'Cómo poner límites y priorizarte sin culpa',
  desc: 'Ejercicios prácticos para decir que no, alejarte de relaciones tóxicas y proteger tu energía.',
  image: 'https://cdn.magicpatterns.com/uploads/8Zo2CifLbFvDN9iMYwucrs/ChatGPT_Image_4_feb_2026,_14_41_44.png'
}, {
  title: 'Amor Propio Práctico',
  subtitle: 'Construye una autoestima sana y real',
  desc: 'No frases vacías. Herramientas concretas para dejar de buscarte en otros y validarte a vos mismo.',
  image: 'https://cdn.magicpatterns.com/uploads/tTjHrzZQ8L6fEtgFoGhwjz/ChatGPT_Image_4_feb_2026,_14_43_01.png'
}, {
  title: 'Detox Afectivo',
  subtitle: 'Sana tu corazón después de una ruptura',
  desc: 'Guía paso a paso para soltar, procesar el duelo y volver a confiar en el amor.',
  image: 'https://cdn.magicpatterns.com/uploads/ozMqRjWDQRZCh7nsk35PLJ/ChatGPT_Image_4_feb_2026,_14_45_26.png'
}];
export function BonusSection() {
  return <section className="py-20 px-4 bg-[#0f0f14] relative overflow-hidden" data-id="element-27">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#d4a853]/5 rounded-full blur-3xl" data-id="element-28"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <span className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider animate-pulse" data-id="element-31">
            🎁 Gratis por hoy
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-32">
            Tus 3 Bonus Exclusivos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-33">
          {bonuses.map((bonus, index) => <div key={index} className="group bg-[#1a1a24] rounded-2xl overflow-hidden border border-white/5 hover:border-[#d4a853]/30 transition-all duration-300 hover:-translate-y-1" data-id="element-34">
              <div className="aspect-[1/1] overflow-hidden bg-black/20 relative p-3 flex items-center justify-center" data-id="element-35">
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a24] to-transparent opacity-50" data-id="element-36"></div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-37" />
              </div>
              <div className="p-6" data-id="element-38">
                <div className="text-[#d4a853] text-xs font-bold uppercase tracking-wider mb-2" data-id="element-39">
                  Bonus #{index + 1}
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-40">
                  {bonus.title}
                </h3>
                <p className="text-sm font-medium text-gray-300 mb-3 italic" data-id="element-41">
                  {bonus.subtitle}
                </p>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-42">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}